module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-4 20h-4v3a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3H6v-2h20v2zm0-10h-4v3a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3H6V8h20v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/align-top-edges-1.js
// module id = 990
// module chunks = 14